import { createFeatureSelector } from '@ngrx/store';
import { CATALOG_FEATURE_NAME } from './feature-name';

export const getCatalogState = createFeatureSelector(CATALOG_FEATURE_NAME);
